import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Grid, TextField } from "@mui/material";

import logo from "../assets/logov2.png";
import useAuth from "../hooks/useAuth";

export default function Login() {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const auth = useAuth();
  const navigate = useNavigate();

  const onLogin = async () => {
    const isLoggedIn = await auth.signin(username, password);
    if (isLoggedIn) {
      navigate("/fulfillment", { replace: true });
    }
  };

  if (auth.user) {
    return <Navigate to="/fulfillment" replace />;
  }
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "primary.main",
        "& .MuiTextField-root": {
          m: 1,
          width: 400,
          maxWidth: "100%",
        },
        "& .MuiButton-root": {
          m: 1,
          mt: 2,
          width: 400,
          maxWidth: "100%",
        },
      }}
    >
      <Grid container justifyContent="center" alignItems="center" sx={{ mb: 5 }}>
        <Grid>
          <img src={logo} alt="ZYN - logo" height="40" />
        </Grid>
      </Grid>
      <Card>
        <CardContent>
          <Grid
            container
            spacing={1}
            direction="column"
          >
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Username"
                variant="filled"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Password"
                variant="filled"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Button
                variant="contained"
                color="primary"
                disabled={!username || !password}
                onClick={onLogin}
                fullWidth
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
